
import RichTextField from '@/components/RichTextField/richTextField.vue'
import { PropType } from 'vue'

export default {
    name: 'HelpText',
    components: {
        RichTextField,
    },
    props: {
        value: {
            type: Object as PropType<Maybe<Record<string, string>>>,
            default: null,
        },
    },
    data() {
        return {
            helpTextLanguage: 'eng',
            helpText: null as Maybe<Record<string, string>>,
        }
    },
    created() {
        this.helpTextLanguage = this.$store.state.user.language
        this.helpText = this.value
    },
    methods: {
        setHelpText(value: string) {
            if (!this.helpText) this.helpText = {}
            if (!value) delete this.helpText[this.helpTextLanguage]
            else this.$set(this.helpText, this.helpTextLanguage, value)
            if (Object.keys(this.helpText).length === 0) this.helpText = null
            this.$emit('input', this.helpText, this.helpTextLanguage)
        },
        handleLanguageChanged() {
            this.$nextTick(() => {
                // @ts-ignore -- focus is not defined in the type definition
                this.$refs.helpTextRef.focus?.()
            })
        },
    },
}
